document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-luckysong-header]').forEach((header) => {
    const hero = document.querySelector('.luckysong-hero');
    const cta = header.querySelector('.luckysong-site-header__cta');

    if (!hero || !cta) return;

    const updateHeaderState = () => {
      header.classList.toggle('is-past-hero', hero.getBoundingClientRect().bottom <= header.offsetHeight);
    };

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
    window.addEventListener('resize', updateHeaderState);
  });
});
